import { Component } from '@angular/core';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { ContentCardModule } from '@app/library/content-card/content-card.module';
import { LibraryElementsModule } from '@app/library/library-elements.module';
import { AbstractContentPane } from '@app/library/panes/models/abstract-content-pane';
import { SpinnersModule } from '@core/components/spinners/spinners.module';
import { ContentService } from '@core/services';

@Component({
  selector: 'app-card-full',
  templateUrl: './card-full.component.html',
  styleUrls: ['./card-full.component.scss'],
  standalone: true,
  imports: [LocaleSharedModule, LibraryElementsModule, SpinnersModule, ContentCardModule],
})
export class CardFullComponent extends AbstractContentPane {
  public item_id: string;
  public contentTypeTitle: string;

  protected onContentLoaded(viaQuery?: boolean): void {
    const item = this.content[0];
    this.item_id = item.id;
    this.contentTypeTitle = ContentService.contentTypeTitle[item.type];
    this.isVisible = !!this.content.length;
  }
}
